<template>
  <div>
    Track
  </div>
</template>

<script>
export default {
  name: 'Track'
}
</script>

<style>

</style>